import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import gridComponent from "@/components/child/grid/grid.vue";
import { GridAction } from "@/components/child/grid/gridAction";
import { GridColors, GridColumn, GridColumnType, GridColumnWithoutSort } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import StatusEnvioSNGPC from "@/models/enum/statusEnvioSNGPC";
import PaginationModel from "@/models/paginationModel";
import SNGPCModel from "@/models/sngpc/sngpcModel";
import SNGPCProdutoModel from "@/models/sngpc/sNGPCProdutoModel";
import SNGPCService from "@/services/sngpc/SNGPCService";
import Delay from "@/utils/common/delay";
import FileHelper from "@/utils/common/fileHelper";

import ListComponentBase from "../crud/listComponentBase";
import ShortcutComponent from "../shortcut/shortcut";
import shortcutComponent from "../shortcut/shortcut.vue";

import SNGPCProdutoListComponent from "./ver";
import sNGPCProdutoListComponent from "./ver.vue";

@Component({
    components: {
        dateTimePickerComponent,
        gridComponent,
        shortcutComponent,
        sNGPCProdutoListComponent,
    },
})
export default class SNGPCListComponent extends ListComponentBase<SNGPCModel> {
    isHidden = false;

    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumnWithoutSort("periodo", "Período", GridColumnType.String),
            new GridColumn("statusEnvioDescricao", "Status", GridColumnType.String),
            new GridColumn("tipo", "Tipo", GridColumnType.String),
            new GridColumn("dataEnvio", "Data de Envio", GridColumnType.Date),
            new GridColumn("dataValidacao", "Data de Validação", GridColumnType.Date),
        ];
    }

    private beforeMount() {
        this.setProps(SNGPCService, "sngpc", "dataEnvio", false, "desc");
    }

    private sNGPCProdutoListComponent: SNGPCProdutoListComponent = null;
    private shortcutComponent: ShortcutComponent = null;
    private shortcutComponentSelecao: ShortcutComponent = null;

    extraActions: Array<object> = [];
    gridExtraActionsVer: Array<GridAction> = [];
    gridExtraActionsEnviarXml: Array<GridAction> = [];
    gridExtraActionsRemover: Array<GridAction> = [];
    gridExtraActionsBaixar: Array<GridAction> = [];
    gridExtraActionsVerReprovacao: Array<GridAction> = [];

    modelVer: Array<SNGPCProdutoModel> = [];

    dataInicio = new Date();
    dataFinal = new Date();
    gerarInventario = false;
    radioFilter: number = null;

    private sngpcVendoIsPendente = false;

    public async afterLoad() {
        this.gridExtraActionsVer.splice(0);
        this.gridExtraActionsEnviarXml.splice(0);
        this.gridExtraActionsRemover.splice(0);
        this.extraActions.splice(0);
        this.gridExtraActionsBaixar.splice(0);
        this.gridExtraActionsVerReprovacao.splice(0);

        for (let i = 0; i < this.gridData.length; i++) {
            this.gridExtraActionsVer.push(
                new GridAction("ver", "Visualizar Produtos", "fa fa-eye", GridColors.BLUE, true),
            );

            this.gridExtraActionsEnviarXml.push(
                new GridAction(
                    "enviar",
                    "Enviar Xml",
                    "fa fa-file-code",
                    GridColors.GREEN,
                    this.gridData[i].statusEnvio == StatusEnvioSNGPC.Pendente,
                ),
            );

            this.gridExtraActionsRemover.push(
                new GridAction(
                    "remover",
                    "Remover",
                    "fa fa-times",
                    GridColors.RED,
                    this.gridData[i].statusEnvio == StatusEnvioSNGPC.Pendente ||
                        this.gridData[i].statusEnvio == StatusEnvioSNGPC.Reprovado,
                ),
            );

            this.gridExtraActionsBaixar.push(
                new GridAction(
                    "baixar",
                    "Baixar Xml",
                    "fa fa-cloud-download-alt",
                    GridColors.GREEN,
                    this.gridData[i].statusEnvio != StatusEnvioSNGPC.Pendente,
                ),
            );

            this.gridExtraActionsVerReprovacao.push(
                new GridAction(
                    "verMotivoReprovacao",
                    "Visualizar o Motivo da Reprovação",
                    "fa fa-exclamation-triangle",
                    GridColors.YELLOW,
                    this.gridData[i].statusEnvio == StatusEnvioSNGPC.Reprovado,
                ),
            );
        }

        this.extraActions.push(this.gridExtraActionsVer);
        this.extraActions.push(this.gridExtraActionsVerReprovacao);
        this.extraActions.push(this.gridExtraActionsEnviarXml);
        this.extraActions.push(this.gridExtraActionsBaixar);
        this.extraActions.push(this.gridExtraActionsRemover);
    }

    private async onGerarInventario() {
        const response = await this.$showQuestion(
            this.$t("__.Components.parent.sngpc.list_vue_html.confirmaGeracaoInventario"),
            this.$t("__.ts.acaoNaoRevert"),
        );

        if (response) {
            try {
                await this.showSelecaoData();
                this.gerarInventario = true;
            } catch {}
        }
    }

    private async onGerarNovo() {
        try {
            await this.showSelecaoData();
            this.gerarInventario = false;
        } catch {}
    }

    private async onConfirmSelecaoData() {
        const isValid = await this.$validator.validateAll();
        if (isValid) {
            this.shortcutComponentSelecao.hide();

            await this.onGerarRelatorio();
        }
    }

    private async onGerarRelatorio() {
        try {
            const sucesso = await SNGPCService.getSNGPCAtual(this.dataInicio, this.dataFinal, this.gerarInventario)
                .withLoading()
                .resolveWithoutJSON();

            if (sucesso) {
                await this.$showSuccess(this.$t("__.ts.inclusao"), this.$t("__.ts.registroSalvSucess"));
                await this.load();
            }
        } catch {}
    }

    private onExtraAction(name: string, model: SNGPCModel) {
        if (name.trim() == "ver") {
            this.onVer(model);
        } else if (name.trim() == "enviar") {
            this.onEnviarXml(model);
        } else if (name.trim() == "baixar") {
            this.onBaixarXml(model);
        } else if (name.trim() == "remover") {
            this.onRemoveItem(model);
        } else if (name.trim() == "verMotivoReprovacao") {
            this.onVerMotivoReprovacao(model);
        }
    }

    private onVerMotivoReprovacao(model: SNGPCModel) {
        const mensagem = this.getMensagemValidacao(model.retornoXml);
        if (!mensagem) {
            return this.$showInfo("Motivo da Rejeição", "A ANVISA não informou o motivo da reprovação.");
        }

        this.$showWarningHtml("Motivo da Rejeição", this.getMensagemFormatada(mensagem));
    }

    // A API REST da ANVISA devolve JSON; o webservice SOAP que ela substituiu devolvia XML. Os
    // arquivos reprovados antes da migração continuam no banco com o XML, então os dois formatos
    // precisam seguir sendo lidos aqui. No JSON o campo vem em PascalCase — o camelCase é lido
    // junto porque o back não depende da caixa e a ANVISA pode trocá-la sem avisar.
    //
    // A reprovação no envio é o terceiro caso, e o mais comum: ali a ANVISA responde a mensagem em
    // texto puro e o back a grava inteira em RetornoXml, então o próprio retorno é o motivo. Essa
    // mensagem traz tags <br> no meio do texto, então procurar "<" para decidir se o retorno é
    // markup escondia justamente o motivo que o operador precisa ler — só a primeira posição vale.
    private getMensagemValidacao(retorno: string): string {
        if (!retorno) {
            return null;
        }

        const texto = retorno.trimStart();

        if (texto.startsWith("{")) {
            try {
                const situacao = JSON.parse(texto);

                return situacao.MensagemValidacao ?? situacao.mensagemValidacao ?? null;
            } catch {
                return null;
            }
        }

        // O `i` cobre o XML legado: a caixa da tag nunca foi garantida pela ANVISA, e um retorno em
        // outra caixa cairia no texto genérico, escondendo o motivo que está gravado ali.
        const match = texto.match(/<MENSAGEMVALIDACAO>([\s\S]*?)<\/MENSAGEMVALIDACAO>/i);
        if (match) {
            return match[1];
        }

        // XML sem a tag de motivo não diz nada a quem opera a farmácia; o que não é markup é a
        // mensagem de reprovação do envio, que vale como texto.
        return texto.startsWith("<") ? null : texto;
    }

    // A ANVISA quebra linha de três jeitos: o marcador [NOVA_LINHA] no XML legado, o pipe entre as
    // frases da mensagem de envio e as próprias tags <br> que ela já manda prontas. Por isso o
    // motivo vai para a tela como HTML — no $showInfo, que escapa o conteúdo, as tags apareceriam
    // literais no meio do texto.
    private getMensagemFormatada(mensagem: string): string {
        return (
            mensagem
                .replaceAll("[NOVA_LINHA]", "<br/>")
                .replaceAll("|", "<br/>")
                // A MENSAGEMVALIDACAO do XML abre com o marcador de quebra, o que renderizaria uma
                // linha em branco antes da primeira linha do motivo.
                .replace(/^(\s*<br\s*\/?>)+/i, "")
                .replace(/(<br\s*\/?>\s*)+$/i, "")
                .trim()
        );
    }

    private async onBaixarXml(model: SNGPCModel) {
        try {
            const response = await SNGPCService.getDataXml(model.id).withLoading().resolveWithResponse();
            if (response.ok) {
                const datablob = await response.blob();
                if (datablob) {
                    const blob = new Blob([datablob], { type: "application/xml" });

                    const fileName = response.headers.get("Content-Disposition").split("filename=")[1].split(";")[0];
                    FileHelper.download(blob, fileName, "application/xml");
                }
            }
        } catch {}
    }

    private async onEnviarXml(model: SNGPCModel) {
        try {
            const sucesso = await SNGPCService.enviarRelatorio(model.id).withLoading().resolveWithoutJSON();

            if (sucesso) {
                await this.$showSuccess("Enviado!", "Registro foi Enviado com sucesso.");
                await this.load();
            }
        } catch {}
    }

    private async onVer(model: SNGPCModel) {
        while (!this.$refs.shortcutComponent) await Delay(100);
        this.shortcutComponent = this.$refs.shortcutComponent as ShortcutComponent;
        this.sNGPCProdutoListComponent = this.$refs.sNGPCProdutoListComponent as SNGPCProdutoListComponent;

        this.sngpcVendoIsPendente = model.statusEnvio === StatusEnvioSNGPC.Pendente;

        const produtos = await SNGPCService.getProdutos(model.id)
            .withLoading()
            .resolveWithJSON<Array<SNGPCProdutoModel>>();

        this.shortcutComponent.title = "Produtos";
        this.sNGPCProdutoListComponent.loadModel(produtos);

        this.shortcutComponent.show();
    }

    private async showSelecaoData() {
        const periodo = await SNGPCService.getProximoPeriodo(this.gerarInventario)
            .withLoading()
            .resolveWithJSON<{ dataInicio: string; dataFinal: string }>();

        this.dataInicio = new Date(periodo.dataInicio);
        this.dataFinal = new Date(periodo.dataFinal);

        while (!this.$refs.shortcutComponentSelecao) await Delay(100);
        this.shortcutComponentSelecao = this.$refs.shortcutComponentSelecao as ShortcutComponent;
        this.shortcutComponentSelecao.title = "Período";
        this.shortcutComponentSelecao.show();
    }

    public async loadMethod() {
        return await SNGPCService.listWithFilter(
            this.gridFilterKey,
            this.gridSortKey,
            this.gridSortOrder,
            this.pags ? 1 : this.pageIndex,
            this.pags ? 999999 : this.pageSize,
            this.radioFilter,
        )
            .withLoading()
            .resolveWithJSON<PaginationModel<SNGPCModel>>();
    }

    private async getFormValues(filtro) {
        this.radioFilter = filtro.target.elements.optradio.value;
        this.isHidden = false;

        await this.load();
    }
}
